import { render, staticRenderFns } from "./queryBackupList.vue?vue&type=template&id=3917b132"
import script from "./queryBackupList.vue?vue&type=script&lang=js"
export * from "./queryBackupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports